import { Config } from "../landing-config";
import { ico_pink } from "../map-config";


const maxFileRows = 500;
export const WAVELENGTH_CONFIG: Config = {
    data: {
        route: 'servizio-wavelength',
        page_title: 'Wavelength | Open Fiber',
        service_title: 'Wavelength',
        service_description: '',
        service_name: '',
        service_slug: 'wavelength',
        errorTimeout: 10000,
        feasibilityModelSingle: false,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '',
                massiveUploadPath: '',
                massiveDownloadPath: '',
                massiveP2pSalesforcePath: '',
                max_file_rows: maxFileRows,
                info_message: null
            },
            p2pPath: '/serviziowavelength/p2p',
			bboxPath: '/marketing/building',
			buildingSearchParams: null
        },
        dynamic_aend_name: ''
    },
    multiple_points: {
        variable: false,
        max: 2,
        points: {
            b_end: {
                default_method: 'address',
                switch_methods: true,
                address: true,
                pop: true,
                poi: true,
                pfs: false,
                roe: false,
				coordinates: true,
                id_building: true,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_building: false,
                city_pop: true,
                city_poi: true,
                id_healthcare: false,
                upload: false,
                popAndPoiAutocomplete: false,
                punti_intermedi: false,
                pop_pcn_xpop: true,
            },
            a_end: {
                default_method: 'pop',
                switch_methods: true,
                address: true,
                pop: true,
                poi: true,
                pfs: false,
                roe: false,
                coordinates: true,
                id_building: true,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: true,
                city_poi: true,
                city_building: false,
                id_healthcare: false,
                upload: false,
                popAndPoiAutocomplete: false,
                punti_intermedi: false,
                pop_pcn_xpop: true,
            }
        },
        initial_points: ['b_end', 'a_end']
    },
    map: {
        map_events: ['zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: true,
        marker_default_icon: ico_pink,
        clear_markers_zoom_level: 12
    },
    research_methods: {
        id_building: true,
        id_bts_noa: false,
        id_bts_building: false,
        id_school: false,
        id_healthcare: false,
        punti_intermedi: false,
        pop_pcn_xpop: true,
    },
    area_types: ['CoveredAB', 'CoveredAGF'],
    area_types_short: null, // TODO encode
    kml: false,
    pop: {
        load: true,
        view_initial: true,
        click: true,
        loadCities: true
    },
    pcn: {
        load: true,
        view_initial: true,
        click: true
    },
    pop_agf: {
        load: false,
        view_initial: false,
        click: false
    },
    poi: {
        load: true,
        view_initial: true,
        click: true,
        x_pop: true,
        is_registered: true,
        custom_research_method: 'Address',
        loadCities: true
    },
    pfs: {
        load: false,
        view_initial: false,
        click: false,
        type: 'PFS'
    },
    roe: {
        load: false,
        view_initial: false,
        click: false,
        type: 'ROE'
    },
    cno: {
        load: false,
        view_initial: false,
        click: false,
        type: 'CNO'
    },
    pozzetto: {
        load: false,
        view_initial: false,
        click: false,
        type: 'POZZETTO'
    },
    building: {
        load: true,
        click: true,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: false,
        click: false,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: false,
        types: null
    },
    punti_intermedi: {
        load: false,
        types: null
    },
    pop_pcn_xpop: {
        load: true,
        types: {
            POP: {
                load: true,
                click: true,
			},
            XPOP: {
                load: true,
                click: true,
            }
        }
    },
    school: {
        load: false,
        click: false,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}
